import { Component, Prop, h, Event, EventEmitter } from '@stencil/core';
import { InputFomat } from '../model/input.model';

@Component({
  tag: 'form-radio',
  styleUrl: 'form-radio.css',
  shadow: false,
})
export class FormRadio {
 @Prop() inputValue: InputFomat;
 @Event() valueChanged: EventEmitter<{ id: string; value: any }>;
  render() {
    return (
    <ix-radio-group
  label={this.inputValue.label}
  name={this.inputValue.id}
  value={this.inputValue.value}
  onChange={(e: CustomEvent) => this.valueChanged.emit({ id: this.inputValue.id, value: e.detail })}
>
  {this.inputValue.options && typeof this.inputValue.options === 'object'
    ? Object.entries(this.inputValue.options).map(([val, label]) => (
        <ix-radio value={val} label={label} name={this.inputValue.id}></ix-radio>
      ))
    : null}
</ix-radio-group>

        );
  }
}

